'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.storefrontRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var storefrontRemote = exports.storefrontRemote = {
    fetchLotsBySellerId: function fetchLotsBySellerId(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            sellerId = _ref.sellerId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>spa/sellers/' + sellerId + '/items' });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/storefront.js
// module id = vC6z
// module chunks = 60